import { WrongCoordinatesVehicle } from '../../../types/anomaliesTypes';
import { TableDispatchAction, TableSortProperties } from '../../../types/types';

export default function tableSortReducer(state: TableSortProperties<WrongCoordinatesVehicle>, action: TableDispatchAction<WrongCoordinatesVehicle>): TableSortProperties<WrongCoordinatesVehicle> {
    if (!action.data)
        return state;

    switch (action.type) {
        case 'CHANGE_SORT': {
            if (state.column === action.column) {
                return {
                    ...state,
                    data: action.data.reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }

            let data = [];
            switch (action.column) {
                case 'id':
                case 'onShape':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                case 'outShape':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                case 'outShapePcnt':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                default:
                    data = action.data;
            }
            return {
                column: action.column,
                data: data,
                direction: 'ascending',
            };
        }
        case 'UPDATE_DATA': {
            return {
                ...state,
                data: action.data || [],
            };
        }
    }
}
